import { fetchApiData } from '../../utils/apiUtils';
import { ENDPOINT } from '../../constants/api';
import * as tableSlice from '../slices/table.slice';

export const getAllTableZone = (businessSlug, branchId) => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/branch-table-zone?branchId=${branchId}`,
    dispatch
  });
  if (data) {
    dispatch(tableSlice.clearTableZone());
    dispatch(tableSlice.setTableZone(data));
  }
};

export const getAllTableData = (businessSlug, zoneId) => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/branch-table?zoneId=${zoneId}`,
    dispatch
  });
  if (data) {
    dispatch(tableSlice.clearTableData());
    dispatch(tableSlice.setTableData(data));
  }
};

export const getTableSeatInfo = businessSlug => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/branch-table/with-seats`,
    dispatch
  });
  if (data) {
    return data;
  }
  return null;
};

export const setReserved = (businessSlug, data) => async dispatch => {
  const response = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/table-reservation`,
    data,
    dispatch
  });
  return response;
};

export const setUsing = (businessSlug, data) => async dispatch => {
  const response = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/customer-table`,
    data,
    dispatch
  });
  return response;
};

export const setMove = (businessSlug, data) => async dispatch => {
  const response = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/table-move`,
    data,
    dispatch
  });
  return response;
};

export const setMerge = (businessSlug, data) => async dispatch => {
  const response = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/table-merge`,
    data,
    dispatch
  });
  return response;
};

export const setTableInUse = (businessSlug, data) => async dispatch => {
  const response = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/branch-table/in-use`,
    data,
    dispatch
  });
  return response;
};

export const getBillByTableId = (businessSlug, tableId) => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/branch-table/${tableId}/bill`,
    dispatch,
    useAuth: true
  });

  if (data) {
    return data;
  }
};

export const clearTable = (businessSlug, tableId) => async dispatch => {
  const response = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/branch-table/clear-table`,
    data: { branch_table_id: tableId },
    dispatch,
    useAuth: true,
  });
  return response;
};

export const updateOrderTable = (businessSlug, orderId, data) => async dispatch => {
  const response = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.POS.replace('{businessSlug}', businessSlug)}/order/${orderId}/table`,
    data,
    dispatch,
    useAuth: true
  });

  return response;
};
